import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { de } from "./de/index_de";
// import LanguageDetector from 'i18next-browser-languagedetector';
import { en } from "./en/index_en";
import { fr } from "./fr/index_fr";
import { es } from "./es/index_es";
import { it } from "./it/index_it";
const is_translator = JSON.parse(process.env.REACT_APP_TRANSLATOR) || false;
const translation = JSON.parse(localStorage.getItem("translation"));
const lang = localStorage.getItem("language") || "en";

const en_strings = { ...en };
const fr_strings = { ...fr };
const de_strings = { ...de };
const es_strings = { ...es };
const it_strings = { ...it };
localStorage.setItem(
  "translation",
  translation && is_translator
    ? JSON.stringify({
        en: { ...en_strings, ...translation.en },
        fr: { ...fr_strings, ...translation.fr },
        de: { ...de_strings, ...translation.de },
        es: { ...es_strings, ...translation.es },
        it: { ...it_strings, ...translation.it },
      })
    : JSON.stringify({
        en: en_strings,
        fr: fr_strings,
        de: de_strings,
        es: es_strings,
        it: it_strings,
      }),
);

console.log(JSON.parse(localStorage.getItem("translation")));
i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  //   .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: process.env.REACT_APP_NODE_ENV !== "production",
    lng: lang, // default language
    fallbackLng: "en",
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },

    resources: {
      en: {
        translation:
          translation && Object.keys(translation).length > 0 && is_translator
            ? { ...translation["en"] }
            : { ...en },
      },
      fr: {
        translation:
          translation && Object.keys(translation).length > 0 && is_translator
            ? { ...translation["fr"] }
            : { ...fr },
      },
      de: {
        translation:
          translation && Object.keys(translation).length > 0 && is_translator
            ? { ...translation["de"] }
            : { ...de },
      },
      es: {
        translation:
          translation && Object.keys(translation).length > 0 && is_translator
            ? { ...translation["es"] }
            : { ...es },
      },

      it: {
        translation:
          translation && Object.keys(translation).length > 0 && is_translator
            ? { ...translation["it"] }
            : { ...it },
      },
    },
  });

export default i18n;
